import React, { useState } from 'react';
import { Box, Typography, IconButton, Paper, Link } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';

const WorkflowTipPopup = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        background: 'rgba(255,255,255, 0.7)',
        zIndex: 9,
      }}
    >
      <Paper
        // component={motion.div}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        elevation={4}
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          p: 0,
          borderRadius: 5,
          display: 'flex',
          alignItems: 'flex-start',
          gap: 0,
          backgroundColor: 'white',
          boxShadow: '0px 10px 22px #00000029',
          border: '1px solid #D2D2D2',
        }}
      >
        {/* Image */}
        <Box
          sx={{
            p: 2,
            margin: 'auto',
          }}
        >
          <Box
            component="img"
            src="/images/workflow/networking.svg"
            alt="Workflow Icon"
            sx={{ width: 80, height: 80, margin: 'auto' }}
          />
        </Box>

        {/* Content */}
        <Box
          flex={1}
          sx={{
            p: 2,
            borderLeft: '1px solid #D2D2D2',
          }}
        >
          <Typography
            variant="caption"
            color="#808081"
            fontWeight="bold"
            style={{ fontSize: '12px' }}
          >
            PRODUCTIVITY TIP
          </Typography>
          <Typography
            variant="subtitle2"
            fontWeight="bold"
            style={{ fontSize: '15px' }}
          >
            How to Create a Workflow?
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            style={{ fontSize: '15px' }}
          >
            1. Drag and drop widgets from the right panel to the canvas <br />
            2. Connect the widgets <br />
            3. Customize each widget by clicking the edit button
          </Typography>
          <Link
            href="#"
            sx={{
              mt: 1,
              display: 'block',
              fontSize: 12,
              color: 'primary.main',
              fontWeight: 'bold',
              textDecoration: 'none',
            }}
          >
            <Box
              component="img"
              src="/images/workflow/play.svg"
              alt="Play Icon"
              sx={{ width: 15, height: 15, margin: 'auto', display: 'inline' }}
            />{' '}
            Watch the video to learn more
          </Link>
        </Box>

        {/* Close Button */}
        <IconButton
          size="small"
          onClick={() => setIsVisible(false)}
          sx={{ position: 'absolute', right: '10px', top: '10px' }}
        >
          <Box
            component="img"
            src="/images/workflow/Close.svg"
            alt="Close Icon"
            sx={{ width: 10, height: 10, margin: 'auto' }}
          />
        </IconButton>
      </Paper>
    </div>
  );
};

export default WorkflowTipPopup;
